import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Calculator from "@/components/Calculator";
import Process from "@/components/Process";
import About from "@/components/About";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import ObdSection from "@/components/ObdSection";
import Booking from "@/components/Booking";
import Faq from "@/components/Faq";
import { useContent } from "@/context/ContentContext";
import { scrollToId } from "@/lib/site";
import { useCallback, useState } from "react";

export default function Home() {
  const [preset, setPreset] = useState(null);
  const applyPreset = useCallback((p) => {
    setPreset(p);
    scrollToId("termin");
  }, []);

  return (
    <main>
      <Hero />
      <Marquee />
      <Services onBook={applyPreset} />
      <Calculator onApply={applyPreset} />
      <Process />
      <About />
      <Gallery />
      <Reviews />
      <ObdSection onQuote={applyPreset} />
      <Booking preset={preset} />
      <Faq />
    </main>
  );
}
